// extracted by mini-css-extract-plugin
module.exports = {"container":"e_3ub","dotBox":"e_4ub","dotBoxImage":"e_5ub","positionedDotBox":"e_6ub","dotBoxMultiply":"e_7ub","dotBoxMultiplyText":"e_8ub"};